/**
 * Scroll reveal for the inner pages.
 *
 * Elements opt in with [data-za-reveal]. The hidden state only applies once
 * this module has armed it, so the content stays visible without JS. Elements
 * already in view on load are revealed immediately, which keeps the first
 * screen from animating in under the reader.
 */
const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

if (!REDUCED.matches) {
  document.documentElement.classList.add('za-reveal-armed');

  const reveal = (element) => element.classList.add('is-revealed');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        reveal(entry.target);
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.01 }
  );

  const watch = (root = document) => {
    for (const element of root.querySelectorAll('[data-za-reveal]:not(.is-revealed)')) {
      if (element.getBoundingClientRect().top < window.innerHeight) {
        reveal(element);
        continue;
      }
      observer.observe(element);
    }
  };

  watch();

  // Sections re-render in the theme editor and on section morphs.
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
  new MutationObserver(() => watch()).observe(document.body, { childList: true, subtree: true });
}
